import { createRouter, createWebHistory } from 'vue-router';
import axios from 'axios'


const routes = [

  // EUS
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/eus/HomeEUS.vue'),
    meta: { title: 'Hasiera' },
  },
  {
    path: '/bio',
    name: 'Bio',
    component: () => import('../views/eus/BioEUS.vue'),
    meta: { title: 'Biografia' },
  },
  {
    path: '/tour',
    name: 'Tour',
    component: () => import('../views/eus/TourEUS.vue'),
    meta: { title: 'Tour' },
  },
  {
    path: '/musika',
    name: 'Musika',
    component: () => import('../views/eus/MusikaEUS.vue'),
    meta: { title: 'Musika' },
  },
  {
    path: '/kontaktua',
    name: 'Kontaktua',
    component: () => import('../views/eus/KontaktuaEUS.vue'),
    meta: { title: 'Kontaktua' },
  },
  {
    path: '/zuentzat',
    name: 'B aldea',
    component: () => import('../views/eus/ZuentzatEUS.vue'),
    meta: { title: 'B Aldea', layout: 'dark' },
  },

  // CAS
  {
    path: '/cas',
    name: 'HomeCAS',
    component: () => import('../views/cas/HomeCAS.vue'),
    meta: { title: 'Home' },
  },
  {
    path: '/cas/bio',
    name: 'BioCAS',
    component: () => import('../views/cas/BioCAS.vue'),
    meta: { title: 'Biografía' },
  },
  {
    path: '/cas/tour',
    name: 'TourCAS',
    component: () => import('../views/cas/TourCAS.vue'),
    meta: { title: 'Tour' },
  },
  {
    path: '/cas/musika',
    name: 'MusikaCAS',
    component: () => import('../views/cas/MusikaCAS.vue'),
    meta: { title: 'Música' },
  },
  {
    path: '/cas/kontaktua',
    name: 'KontaktuaCAS',
    component: () => import('../views/cas/KontaktuaCAS.vue'),
    meta: { title: 'Contacto' },
  },
  {
    path: '/cas/zuentzat',
    name: 'B aldeaCAS',
    component: () => import('../views/cas/ZuentzatCAS.vue'),
    meta: { title: 'B Aldea', layout: 'dark' },
  },
  // Redirección genérica
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
    meta: { title: 'BURUTIK' },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // if (savedPosition) {
    //   return savedPosition
    // }
    return { top: 0, left: 0 }
  }
})
router.beforeEach(async (to, from, next) => {
  if (to.path === "/zuentzat" || to.path === "/cas/zuentzat") {
    try {
      let qr_token = to.query.token;

      if (qr_token) {
        localStorage.setItem("qr_token", qr_token);

        const res = await axios.get(`/qr_auth/check`, {
          headers: { Authorization: `Bearer ${qr_token}` }
        });

        if (!res.data.ok) {
          return next("/__no_existe__");
        }

        // 👇 Solo redirigimos si había query
        return next({
          path: to.path,
          query: {},   // elimina todos los query params
          replace: true
        });
      }

      // Si no viene en la URL, usamos localStorage
      qr_token = localStorage.getItem("qr_token");

      if (!qr_token) {
        return next("/__no_existe__");
      }

      const res = await axios.get(`/qr_auth/check`, {
        headers: { Authorization: `Bearer ${qr_token}` }
      });

      if (!res.data.ok) {
        return next("/__no_existe__");
      }

    } catch (err) {
      console.log(err);
      return next("/__no_existe__");
    }
  }

  next();
});

// Actualizar el título del documento según la metaetiqueta de la ruta
router.afterEach((to) => {
  document.title = `BURUTIK | ${to.meta.title}` || 'BURUTIK';
})
export default router;
